import * as types from './userActionTypes';
import * as authTypes from '../Auth/authActionTypes';

const initialState = {
    username: '',
    email: '',
    emailParent:'',
    avatar: '',
    birthday: '',
    city: '',
    commentCGURead: true,
    isAdmin: false,
    hasUnreadJournalistMessage: false,
    userCreated: false,
    lastTimeLoggedIn: '', //used to check the last time logged in in the subscription check, it must not be changed before !!!
    hasError: false,
    errorMessage: '',
    errorCode:''
};

const createUserSuccess = (state, action) => {
    const { userId } = action;
    return {
        ...state,
        isUserSignedIn: true,
        isInProgress: false,
        userCreated: true,
        uid: userId
    };
}

const createUser = (state, action) => {
    return {
        ...state,
        isInProgress: true
    };
}

const createUserError = (state, action) => {
    const { errorMessage, errorCode } = action;
    return {
        ...state,
        hasError: true,
        isInProgress: false,
        errorMessage,
        errorCode
    };
}

const getUserSuccess = (state, action) => {
    const { username, email, emailParent, city, birthday, avatarId, commentCGURead, isAdmin, lastTimeLoggedIn } = action;
    return {
        ...state,
        isInProgress: false,
        username,
        email, 
        emailParent,
        city,
        birthday,
        avatar: avatarId,
        commentCGURead,
        isAdmin,
        lastTimeLoggedIn
    };
}

const getUser = (state, action) => {
    return {
        ...state,
        isInProgress: true
    };
}

const getUserError = (state, action) => {
    const { getErrorMessage } = action;
    return {
        ...state,
        hasError: true,
        isInProgress: false,
        errorMessage: getErrorMessage
    };
}

const userReadCGU = (state, action) => {
    return {
        ...state,
        commentCGURead: true
    }; 
}

const userReadCGUError = (state, action) => {
    const { errorMessage } = action;
    return {
        ...state,
        hasError: true,
        errorMessage
    }
}

const clearErrors = (state, action) => {
    return {
        ...state,
        hasError: false,
        errorMessage: '',
        errorCode: ''
    }
}

const hasUnreadJournalistMessage = (state, action) => {
    const {hasUnreadJournalistMessage} = action;
    return {
        ...state,
        hasUnreadJournalistMessage
    }
}

const signinSuccess = (state, action) => {
    const { uid } = action;
    return {
        ...state,
        isUserSignedIn: true,
        isInProgress: false,
        hasError: false,
        errorMessage: '',
        uid
    }
}

const logoutSuccess = (state, action) => {
    return {
        ...state,
        username: '',
        email: '',
        emailParent:'',
        avatar: '',
        birthday: '',
        city: '',
        hasError: false,
        errorMessage: '',
        errorCode:''
    }
}

export const user = (state = initialState, action) => {
    switch(action.type) {
        //CREATEUSER
        case types.CREATEUSER_SUCCESS:              return createUserSuccess(state, action);
        case types.CREATEUSER:                      return createUser(state,action);
        case types.CREATEUSER_ERROR:                return createUserError(state, action);
          
        //GETUSER
        case types.GETUSER_SUCCESS:                 return getUserSuccess(state, action);
        case types.GETUSER:                         return getUser(state, action);
        case types.GETUSER_ERROR:                   return getUserError(state, action);
        
        //COMMENT CGU
        case types.USER_READ_CGU:                   return userReadCGU(state, action);
        case types.USER_READ_CGU_ERROR:             return userReadCGUError(state, action);

        //CLEAR ERROR
        case types.CLEAR_ERRORS:                    return clearErrors(state, action);

        //UNREAD MESSAGE IN CHAT WITH JOURNALIST
        case types.HAS_UNREAD_JOURNALIST_MESSAGE:   return hasUnreadJournalistMessage(state, action);

        //SIGNIN
        case authTypes.SIGNIN_SUCCESS:              return signinSuccess(state, action);
            
        //LOGOUT
        case authTypes.LOGOUT_SUCCESS:              return logoutSuccess(state, action);
            
        default:                                    return state;
    }
}

export default user;


// WEBPACK FOOTER //
// ./src/components/user/userReducers.js